import { jsx } from "panel";
import { TrackingEvent } from "common/report/dashboards/tracking";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { TileEl, TileTheme } from "common/components/tile";
import { TemplateSpecsTranslationKey } from "common/report/dashboards/types";
import { promptFeedbackModal } from "common/widgets/feedback-modal";
import { FeedbackForFeature } from "common/widgets/feedback-modal/types";
export const PAGE_LOADED_TOOLTIP = "This is how Page Views are tracked on your website.";
export const PAGE_NAME_TOOLTIP = "This is how Page Names are tracked on your website.";
export function template() {
  var _this$TEMPLATE_CONFIG;
  const getTemplateCards = () => {
    return Object.keys(this.TEMPLATE_CONFIGS).filter((configKey) => this.TEMPLATE_CONFIGS[configKey].hasFeatureFlag()).map((templateType) => {
      const templateSpec = this.TEMPLATE_CONFIGS[templateType];
      return /* @__PURE__ */ jsx(TileEl, { params: {
        imageId: templateSpec.imageId,
        title: TemplateSpecsTranslationKey[templateType].title,
        description: TemplateSpecsTranslationKey[templateType].description,
        theme: TileTheme.FULL_IMAGE,
        selected: this.state.selectedTemplate === templateType,
        titleBadge: templateSpec.titleBadge
      }, on: {
        click: () => this.update({
          selectedTemplate: templateType
        })
      } });
    });
  };
  const loading = this.attr("loading");
  return /* @__PURE__ */ jsx("div", { attrs: {
    elref: "boardsTemplateModal"
  }, sel: ".mp-modal-container", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-modal-header" }, /* @__PURE__ */ jsx("div", { sel: ".mp-modal-header-title" }, this.t("boards.template-modal.title")), /* @__PURE__ */ jsx("div", { sel: ".mp-modal-subtitle" }, this.t("boards.template-modal.description"), " ", /* @__PURE__ */ jsx("a", { on: {
    click: () => promptFeedbackModal({
      feature: FeedbackForFeature.FoundationalTemplates
    })
  } }, this.t("boards.template-modal.leave-feedback")))), /* @__PURE__ */ jsx("div", { sel: ".mp-modal-content" }, /* @__PURE__ */ jsx("div", { sel: ".template-cards" }, getTemplateCards())), /* @__PURE__ */ jsx("div", { sel: ".modal-footer" }, /* @__PURE__ */ jsx("div", { sel: ".modal-actions" }, this.state.selectedTemplate && ((_this$TEMPLATE_CONFIG = this.TEMPLATE_CONFIGS[this.state.selectedTemplate]) === null || _this$TEMPLATE_CONFIG === void 0 ? void 0 : _this$TEMPLATE_CONFIG.demoBoardLink) && /* @__PURE__ */ jsx(ButtonEl, { sel: ".modal-actions-preview", attrs: {
    theme: ButtonTheme.Tertiary,
    disabled: !this.state.selectedTemplate,
    elref: "previewTemplateButton"
  }, on: {
    click: () => {
      this.track(TrackingEvent.ClickPreviewTemplate, {
        "Selected Template": this.state.selectedTemplate
      });
      window.open(this.TEMPLATE_CONFIGS[this.state.selectedTemplate].demoBoardLink, "_blank");
    }
  } }, this.t("boards.template-modal.view-preview")), /* @__PURE__ */ jsx(ButtonEl, { sel: ".modal-actions-apply", attrs: {
    theme: ButtonTheme.Primary,
    disabled: !this.state.selectedTemplate || loading,
    elref: "startFromTemplateButton",
    icon: loading ? "spinner" : ""
  }, on: {
    click: this.helpers.advanceToEventSelectionStep
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, loading ? this.t("boards.template-modal.creating") : this.t("boards.template-modal.start-template")))));
}
